// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n.AddToCart[data-v-ae3a4178]{\n  height:48px;\n}\n@media (min-width: 1024px){\n[dir=ltr] .AddToCart[data-v-ae3a4178]{padding-left:1.25rem;padding-right:1.25rem\n}\n[dir=rtl] .AddToCart[data-v-ae3a4178]{\n    padding-right:1.25rem;\n\n    padding-left:1.25rem\n}\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
